import { render, staticRenderFns } from "./IndemnityPriceTemplateEditModal.vue?vue&type=template&id=5f40cd72&scoped=true"
import script from "./IndemnityPriceTemplateEditModal.vue?vue&type=script&lang=js"
export * from "./IndemnityPriceTemplateEditModal.vue?vue&type=script&lang=js"
import style0 from "./IndemnityPriceTemplateEditModal.vue?vue&type=style&index=0&id=5f40cd72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40cd72",
  null
  
)

export default component.exports